import request from '@/axios'

export const getSystemConfigApi = (): Promise<IResponse> => {
  return request.get({ url: '/system/config' })
}

export const updateSystemConfigApi = (data: any): Promise<IResponse<null>> => {
  return request.post({ url: '/system/config', data })
}

export const initSystemDataApi = (data: any): Promise<IResponse<null>> => {
  return request.post({ url: '/system/init_data', data })
}

export const getStaffListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/staff/list', params })
}

export const deleteStaffApi = (id: string): Promise<IResponse> => {
  return request.post({ url: `/system/staff/delete`, data: { id } })
}

export const setStaffApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/staff/set', data })
}

// ── 员工角色（绑定式 + 写时同步权限快照）────────────────────────────────
// 注意：与框架 demo 的 `@/api/role`（/mock/role/table）无关，那是演示页用的。
export const getRoleListApi = (): Promise<IResponse> => {
  return request.get({ url: '/system/role/list' })
}

export const setRoleApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/role/set', data })
}

export const deleteRoleApi = (id: number): Promise<IResponse> => {
  return request.post({ url: '/system/role/delete', data: { id } })
}

// ── 首页看板布局 ───────────────────────────────────────────────────────
// platform 固定 'app'：与 App 端共用同一份布局（管理员配一次两端一致）。
// 传 'web' 会各存一份、两端不同步，见《46-Web端对齐App1.1.0改造方案.md》§2.2.1。
const HOME_LAYOUT_PLATFORM = 'app'

export const getHomeLayoutApi = (): Promise<IResponse> => {
  return request.get({ url: '/system/home_layout', params: { platform: HOME_LAYOUT_PLATFORM } })
}

export const setHomeLayoutApi = (keys: string[]): Promise<IResponse> => {
  return request.post({
    url: '/system/home_layout/set',
    data: { platform: HOME_LAYOUT_PLATFORM, keys }
  })
}

export const getSalesmanListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/salesman/list', params })
}

export const deleteSalesmanApi = (id: string): Promise<IResponse> => {
  return request.post({ url: `/system/salesman/delete`, data: { id } })
}

export const setSalesmanApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/salesman/set', data })
}

export const getNoRuleListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/order_no_rule/list', params })
}

export const updateNoRuleApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/order_no_rule/update', data })
}

export const getOperationLogListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/operation_log/list', params })
}

export const deleteOperationLogApi = (): Promise<IResponse> => {
  return request.post({ url: `/system/operation_log/delete` })
}

export const getPrinterTemplateListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/printer/template_list', params })
}

export const deletePrinterTemplateApi = (id: string): Promise<IResponse> => {
  return request.post({ url: `/system/printer/template_delete`, data: { id } })
}

export const setPrinterTemplateApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/printer/template_set', data })
}

export const GeneratePrinterTokenApi = (): Promise<IResponse> => {
  return request.post({ url: '/system/printer_token' })
}

export const setDefaultPrinterTemplateApi = (id: number): Promise<IResponse> => {
  return request.post({ url: '/system/printer/template_set_default', data: { id } })
}

export const getPrinterDataApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/printer/data', params })
}

export const getBackupListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/backup/list', params })
}

export const manualBackupApi = (name: string, note: string): Promise<IResponse> => {
  return request.post({ url: '/system/backup/manual', data: { name, note } })
}

export const restoreBackupApi = (hash_id: string): Promise<IResponse> => {
  return request.post({ url: `/system/backup/restore`, data: { hash_id } })
}

export const deleteBackupApi = (hash_id: string): Promise<IResponse> => {
  return request.post({ url: `/system/backup/delete`, data: { hash_id } })
}

export const updatePasswordApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/update_password', data })
}

export const updateHeadImgApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/update_head_img', data })
}

export const getUserListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/admin/user/list', params })
}

export const setUserApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/admin/user/set', data })
}

export const deleteUserApi = (id: number): Promise<IResponse> => {
  return request.post({ url: `/admin/user/delete`, data: { id } })
}

// ─── 租户运营洞察（超管）─────────────────────────────────────────────────────

/** 只改联系方式（列表页行内编辑）。不复用 setUserApi：那个要整行字段全带上 */
export const setUserContactApi = (id: number, contact: string): Promise<IResponse> => {
  return request.post({ url: '/admin/user/contact', data: { id, contact } })
}

/** 租户详情：概览 / 趋势 / 功能分布 / 子账号 / 登录记录 / 最近跟进 */
export const getUserDetailApi = (id: number): Promise<IResponse> => {
  return request.get({ url: '/admin/user/detail', params: { id } })
}

/** 操作流水（默认隐藏心跳）。粒度到「新增销售单」，要单号走「查看数据」 */
export const getUserFlowApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/admin/user/flow', params })
}

/** 客服跟进记录 */
export const getUserNoteListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/admin/user/note/list', params })
}

export const addUserNoteApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/admin/user/note/add', data })
}

export const updateUserNoteApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/admin/user/note/update', data })
}

export const deleteUserNoteApi = (id: number): Promise<IResponse> => {
  return request.post({ url: '/admin/user/note/delete', data: { id } })
}

export const getGradePriceListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/grade_price/list', params })
}

export const updateGradePriceApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/grade_price/update', data })
}

export const setTableColumnApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/table_column/set', data })
}
